/** Ab hier warnt das Banner ruhig, dass die Sitzung bald endet. */
export const SUPPORT_WARNING_MS = 5 * 60_000;

export function remainingMs(expiresAt: string, now: number): number {
  return Math.max(0, Date.parse(expiresAt) - now);
}

/**
 * Restzeit in ganzen Minuten, aufgerundet: „1 Min.“ steht, solange überhaupt Zeit bleibt — eine
 * abgerundete Null läse sich wie „schon vorbei“.
 */
export function formatRemaining(ms: number): string {
  if (ms < 60_000) return 'unter einer Minute';
  const minutes = Math.ceil(ms / 60_000);
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} Min.`;
  return rest === 0 ? `${hours} Std.` : `${hours} Std. ${rest} Min.`;
}

export interface SupportTime {
  text: string;
  warning: boolean;
}

export function supportTime(ms: number): SupportTime {
  if (ms <= 0) return { text: 'abgelaufen', warning: true };
  const remaining = formatRemaining(ms);
  return ms <= SUPPORT_WARNING_MS
    ? { text: `läuft in ${remaining} ab`, warning: true }
    : { text: `noch ${remaining}`, warning: false };
}
